export default "__VITE_ASSET__Gvni19yX__"